import { api } from './api.js'
import type { StartAktionen } from './routes/Start.js'

/**
 * Die Direktaktionen der Startseite (Anf. 77, Szenarien 1, 2 und 6).
 *
 * Hier steckt die Arbeit, die den Unterschied zwischen zwei und vier Tipps
 * ausmacht: **Der Raum wird beschafft, nicht erfragt.** Gibt es noch keinen
 * Direkt-Chat mit dieser Person, legt der Client ihn im selben Zug an. Der
 * Nutzer merkt davon nichts — für ihn hat er einmal auf „Nachricht" getippt.
 *
 * Ausgelagert aus `Start.tsx`, damit die Oberfläche testbar bleibt, ohne dass
 * ein Test das Netz braucht: Die Komponente bekommt die Aktionen übergeben.
 */
export function direktAktionen(): StartAktionen {
  /**
   * Liefert den Direkt-Raum mit dieser Person — vorhanden oder neu.
   *
   * `POST /rooms/direct` ist absichtlich idempotent (Phase 4): Zwei parallele
   * Aufrufe erzeugen keinen zweiten Raum, sondern liefern denselben.
   */
  async function raumFuer(personId: string, bekannt: string | null): Promise<string> {
    if (bekannt) return bekannt
    const res = await api.post<{ roomId: string }>('/rooms/direct', { personId })
    return res.roomId
  }

  return {
    onChat(personId, roomId) {
      void raumFuer(personId, roomId).then((id) => {
        location.hash = `#chat/${id}`
      })
    },

    onAnruf(personId, roomId, kind) {
      void raumFuer(personId, roomId)
        .then((id) => api.post<{ id: string }>('/calls', { roomId: id, kind }))
        .then(() => { location.hash = '#anrufen' })
    },

    onFoto(personId, roomId) {
      // Der Chat übernimmt das Auswählen und Verschlüsseln. Der Umweg ist
      // Absicht: Ein Foto zu senden heißt, eine Nachricht zu senden — nur mit
      // Bild statt Text. Ein zweiter Weg dafür wäre ein zweiter Ort, an dem
      // die Verschlüsselung richtig sein muss.
      void raumFuer(personId, roomId).then((id) => {
        location.hash = `#chat/${id}?foto=1`
      })
    },
  }
}
